module.exports = __webpack_public_path__ + "static/media/plus-Faq.4d65da82.svg";